import {NavigationEntityState} from '~ui/store/slices/navigation-tree';

// TODO
export const getOpenAroundNodeSlug = (
    entities: Record<string, NavigationEntityState>,
    openItemSlug: string,
) => {
    const item = entities[openItemSlug];

    // we can only get `openAroundNodeSlug` for the items
    // in needs-expand state.
    if (!item || item.expandedState !== 'needs-expand') {
        return;
    }

    const childItem = item.children[0] ? entities[item.children[0]] : undefined;

    if (!childItem) {
        return;
    }

    // if item has virtual slug and it doesn't equal to it's real slug
    // it means that this child has been moved to this place and not
    // saved there yet. therefore we can't use it to open item
    if (childItem.virtualSlug && childItem.virtualSlug !== childItem.slug) {
        return;
    }

    return childItem.slug;
};
